import Component from './Component'
import Record from '../Record'

export default class FormArray extends Component {

	static _type = 'FormArray'

	form			// Parent form component

	tether () {
		super.tether()

		// Own DOM elements
		this.add_btn = document.getElementById(`${this.id}_add_btn`)
		this.array_area = document.getElementById(`${this.id}_array_area`)

		// Register event handlers
		$(this.add_btn).on('click', this.addRowListener)								// jQuery event
		$(this.array_area).on('click', '.remove-btn', this.removeRowListener)			// jQuery event
		this.params.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		/*
		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
		*/
	}

	updateListener = async (value, errors) => {
		await Anvil.render('/ui/form/form_array_area', {
			array: this.params.data[this.params.name],
			name_prefix: `${this.params.prefix}_${this.params.name}`,
			placeholder: this.params.placeholder,
			fields: this.params.fields
		}, this.array_area)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.params.data[this.params.name], this.params)
		}
	}

	addRowListener = async () => {
		if (this.params.model) {
			var record = await this.params.model.fetch()
		} else {
			var record = new Record({})
		}
		this.params.data[this.params.name] = [ ...this.params.data[this.params.name], record ]
	}

	removeRowListener = (event) => {
		const record = event.target.closest('form[anvil-component]').anvil.data
		const i = this.params.data[this.params.name].indexOf(record)
		const array = [ ...this.params.data[this.params.name] ]
		array.splice(i, 1)
		this.params.data[this.params.name] = array
	}

	renderValidation (errors) {

	}

	destroy () {

		// Unregister event handlers
		$(this.add_btn).off('click', this.addRowListener)
		$(this.array_area).off('click', '.remove-btn', this.addRowListener)
		this.params.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.form
		delete this.add_btn
		delete this.array_area

		super.destroy()
	}
}
